<template>
  <transition name="modal-fade">
    <div
      v-if="visible"
      class="modal-overlay"
      style="position: fixed; inset: 0; z-index: 1050; display: flex; align-items: center; justify-content: center; background-color: rgba(0, 0, 0, 0.5);"
      @click.self="handleBackdropClick"
    >
      <div
        class="modal-container"
        style="background-color: #283046; border-radius: 0.5rem; box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3); max-width: 28rem; width: 100%; margin: 0 1rem;"
        :style="modalStyle"
      >
        <!-- Header -->
        <div
          class="modal-header-custom"
          style="display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid rgba(255, 255, 255, 0.05);"
        >
          <h5 style="color: #d0d2d6; margin: 0; padding: 0; font-size: 1.125rem; font-weight: 500; line-height: 1;">
            {{ title }}
          </h5>
          <button
            v-if="showCloseButton"
            @click="handleClose"
            class="btn-close-custom"
            style="background: #161d31; color: #b4b7bd; border: none; cursor: pointer; padding: 0.25rem; border-radius: 0.375rem; display: flex; align-items: center; justify-content: center; line-height: 1;"
            @mouseenter="$event.target.style.backgroundColor = '#3b4253'"
            @mouseleave="$event.target.style.backgroundColor = '#161d31'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body-custom" style="padding: 1.25rem; color: #b4b7bd;">
          <slot></slot>
        </div>

        <!-- Footer -->
        <div
          v-if="showFooter"
          class="modal-footer-custom"
          style="display: flex; align-items: center; justify-content: flex-end; gap: 0.75rem; padding: 1rem 1.25rem; border-top: 1px solid rgba(255, 255, 255, 0.05);"
        >
          <slot name="footer">
            <button
              v-if="cancelText"
              @click="handleCancel"
              class="btn-cancel-custom"
              style="background: transparent; color: #b4b7bd; border: 1px solid #3b4253; cursor: pointer; font-size: 0.875rem; padding: 0.5rem 1rem; border-radius: 0.375rem; line-height: 1;"
              @mouseenter="$event.target.style.backgroundColor = '#3b4253'; $event.target.style.color = '#d0d2d6'"
              @mouseleave="$event.target.style.backgroundColor = 'transparent'; $event.target.style.color = '#b4b7bd'"
            >
              {{ cancelText }}
            </button>
            <button
              v-if="okText"
              @click="handleOk"
              class="btn-confirm-custom"
              :style="`background: ${okVariant === 'danger' ? '#ea5455' : '#7367f0'}; color: #fff; border: none; cursor: pointer; font-size: 0.875rem; padding: 0.5rem 1rem; border-radius: 0.375rem; line-height: 1;`"
              @mouseenter="$event.target.style.backgroundColor = okVariant === 'danger' ? '#df4759' : '#615bdb'"
              @mouseleave="$event.target.style.backgroundColor = okVariant === 'danger' ? '#ea5455' : '#7367f0'"
            >
              {{ okText }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CustomModalTailwind',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    okVariant: {
      type: String,
      default: 'primary', // 'primary' or 'danger'
      validator: value => ['primary', 'danger'].includes(value)
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'md' // 'sm', 'md', 'lg'
    }
  },
  computed: {
    modalStyle() {
      const sizes = {
        sm: 'max-width: 20rem;',
        md: 'max-width: 28rem;',
        lg: 'max-width: 40rem;'
      }
      return sizes[this.size] || sizes.md
    }
  },
  methods: {
    handleOk() {
      this.$emit('ok')
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleClose() {
      this.$emit('close')
      this.$emit('cancel')
    },
    handleBackdropClick() {
      if (this.closeOnBackdrop) {
        this.handleClose()
      }
    }
  }
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.2s ease;
}

.modal-fade-enter .modal-container {
  transform: scale(0.9);
}

.modal-fade-leave-to .modal-container {
  transform: scale(0.9);
}
</style>
